module.exports = __webpack_public_path__ + "img/oaknest-11.c5d72af3.jpeg";